var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGlobal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1a7 7 0 110 14A7 7 0 018 1zm0 1c-.349 0-.69.03-1.022.088l.343 1.205a.375.375 0 01-.228.454L4.307 4.792a.375.375 0 00-.203.519l.584 1.17a.375.375 0 00.335.207h.926c.1 0 .195.04.265.11l1.13 1.129a.374.374 0 00.174.098l1.212.304a.375.375 0 01.25.519l-1.777 3.91a.375.375 0 01-.606.11l-.412-.412a.376.376 0 01-.103-.191l-.375-1.877a.377.377 0 00-.228-.276l-1.71-.683a.376.376 0 01-.229-.422l.314-1.569a.375.375 0 00-.236-.424l-1.424-.535a6 6 0 0010.827 4.803l-.86-3.01a.375.375 0 00-.36-.271h-1.382a.376.376 0 01-.335-.208L9.03 5.687a.375.375 0 01.143-.49l1.765-1.06a.375.375 0 01.267-.045l1.604.32a6.023 6.023 0 00-2.239-1.835.386.386 0 01-.106.073l-.987.461a.375.375 0 01-.327-.004l-.475-.238a.375.375 0 01-.204-.382l.056-.463A6.076 6.076 0 008 2z",
    fill: "#007CB5"
  })));
}

export default SvgIconGlobal;